import {
    GETNOTIFICATIONCONFIGPARTNER_SUCCESS,
    GETNOTIFICATIONCONFIGPARTNER_FAILED,
    RESET_GETNOTIFICATIONCONFIGPARTNER,
    LOADING_GETNOTIFICATIONCONFIGPARTNER,
    NETWORK_ERROR_GETNOTIFICATIONCONFIGPARTNER,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {

    switch (action.type) {
        case LOADING_GETNOTIFICATIONCONFIGPARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETNOTIFICATIONCONFIGPARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETNOTIFICATIONCONFIGPARTNER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_GETNOTIFICATIONCONFIGPARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETNOTIFICATIONCONFIGPARTNER:
            return (state = initialState);
        default:
            return state;
    }
};
